import { PAGES } from '../Admin.constants.tsx';
import i18n from '../../../utils/i18n';

export const getAdminLinks = (data: { entity: string; count: number }[]) => [
  {
    id: 1,
    name: i18n.t('pages.admin.module.distribution-lists'),
    path: '/admin/distribution-lists',
    count: data?.find((e: { entity: string }) => e.entity === PAGES.DISTRIBUTION_LISTS)?.count || 0,
  },
  {
    id: 2,
    name: i18n.t('pages.admin.module.email-templates'),
    path: '/admin/email-templates',
    count: data?.find((e: { entity: string }) => e.entity === PAGES.EMAIL_TEMPLATE)?.count || 0,
  },
  {
    id: 3,
    name: i18n.t('pages.admin.module.organization-unit-lists'),
    path: '/admin/organization-unit-lists',
    count:
      data?.find((e: { entity: string }) => e.entity === PAGES.ORGANIZATION_UNIT_LISTS)?.count || 0,
  },
  // {
  //   id: 5,
  //   name: i18n.t('pages.admin.module.target-groups'),
  //   path: '/admin/target-groups',
  //   count: data?.find((e: { entity: string }) => e.entity === PAGES.TARGET_GROUPS)?.count || 0,
  // },
  {
    id: 6,
    name: i18n.t('pages.admin.module.topics'),
    path: '/admin/topics',
    count: data?.find((e: { entity: string }) => e.entity === PAGES.TOPICS)?.count || 0,
  },
  {
    id: 7,
    name: i18n.t('pages.admin.module.users'),
    path: '/admin/users',
    count: data?.find((e: { entity: string }) => e.entity === PAGES.USERS)?.count || 0,
  },
  {
    id: 8,
    name: i18n.t('pages.admin.module.raw-regulations'),
    path: '/admin/raw-regulations',
    count: data?.find((e: { entity: string }) => e.entity === PAGES.REGULATIONS)?.count || 0,
  },
];